import {checkIfCentralQuarter} from './checkIfCentralQuarter';

export const checkIfAdjacentToCentralQuarter = (hexKey, hexes, hexMath) => {
  const [q, r] = hexKey.split(',').map(Number);
  return hexMath.getNeighborsFlatTop(q, r).some(([nq, nr]) => checkIfCentralQuarter(hexes[`${nq},${nr}`]));
};
